import { analyticsPath } from './cookie-consent'

// Basic consent mode: do not request Google's script before opt-in.
export function createGoogleAnalytics ({ win, doc, router, id, tagId, enabled, allowed }) {
  let started = false
  let configured = false
  let lastPath = null
  const validId = typeof id === 'string' && /^G-[A-Z0-9]+$/.test(id) &&
    typeof tagId === 'string' && /^GT-[A-Z0-9]+$/.test(tagId)
  const disabledKey = 'ga-disable-' + id
  const denied = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' }
  const command = function () { win.jatyAnalyticsDataLayer.push(arguments) }
  const location = path => win.location.origin + path
  function view (route) {
    if (!configured || !allowed()) return
    const path = analyticsPath(router, route.path)
    if (lastPath === path) return
    lastPath = path
    command('event', 'page_view', { send_to: id, page_location: location(path), page_title: 'JaTy', page_referrer: '' })
  }
  function update (granted) {
    if (!enabled || !validId) return
    win[disabledKey] = !granted
    if (!granted) {
      lastPath = null
      if (started) command('consent', 'update', denied)
      return
    }
    if (!started) {
      started = true
      win.jatyAnalyticsDataLayer = []
      command('consent', 'default', denied)
      command('set', 'ads_data_redaction', true)
      command('set', 'url_passthrough', false)
      command('consent', 'update', { ...denied, analytics_storage: 'granted' })
      command('js', new Date())
      const path = analyticsPath(router, router.currentRoute.path)
      // The measurement ID remains an alias of the old combined Google tag.
      // Configure/load the separate JaTy tag; route events to the GA4 stream.
      command('config', tagId, {
        send_page_view: false,
        page_location: location(path), page_title: 'JaTy', page_referrer: '',
        ignore_referrer: true,
        allow_google_signals: false, allow_ad_personalization_signals: false,
        cookie_expires: 180 * 86400, cookie_update: false,
        cookie_flags: 'SameSite=Lax;Secure'
      })
      configured = true
      const script = doc.createElement('script')
      script.id = 'jaty-google-analytics'
      script.async = true
      script.referrerPolicy = 'no-referrer'
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId + '&l=jatyAnalyticsDataLayer'
      doc.head.appendChild(script)
    } else {
      command('consent', 'update', { ...denied, analytics_storage: 'granted' })
    }
    view(router.currentRoute)
  }
  return { update, view }
}
